import HeaderText from 'components/shared/header-text';

import { aboutData } from 'data/templates/about';

import DescriptionEntry from 'components/shared/description-entry';

import '../index.scss';

const AboutTab = () => (
  <div className="tab-view">
    <HeaderText
      fontSize="30px"
      fontWeight="bold"
      margin="0 0 40px 0"
      text="About Templates"
    />
    <div className="inner-tab-content">
      {aboutData?.items?.map((entry) => (
        <DescriptionEntry entry={entry} key={entry?.title} />
      ))}
    </div>
  </div>
);

export default AboutTab;
